var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingSidebar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 6.00004C1.86442 6.00004 2.37313 6.21075 2.7482 6.58583C3.12327 6.9609 3.33398 7.46961 3.33398 8.00004C3.33398 8.53047 3.12327 9.03918 2.7482 9.41425C2.37313 9.78933 1.86442 10 1.33398 10V11.3334C1.33398 11.687 1.47446 12.0261 1.72451 12.2762C1.97456 12.5262 2.3137 12.6667 2.66732 12.6667H13.334C13.6876 12.6667 14.0267 12.5262 14.2768 12.2762C14.5268 12.0261 14.6673 11.687 14.6673 11.3334V10C14.1369 10 13.6282 9.78933 13.2531 9.41425C12.878 9.03918 12.6673 8.53047 12.6673 8.00004C12.6673 7.46961 12.878 6.9609 13.2531 6.58583C13.6282 6.21075 14.1369 6.00004 14.6673 6.00004V4.66671C14.6673 4.31309 14.5268 3.97395 14.2768 3.7239C14.0267 3.47385 13.6876 3.33337 13.334 3.33337H2.66732C2.3137 3.33337 1.97456 3.47385 1.72451 3.7239C1.47446 3.97395 1.33398 4.31309 1.33398 4.66671V6.00004Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 3.33337V4.66671",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 11.3334V12.6667",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 7.33337V8.66671",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingSidebar);
export default __webpack_public_path__ + "static/media/booking_sidebar.0afa24f0c1e3b047234178ef1e9330d3.svg";
export { ForwardRef as ReactComponent };